import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import Sign from "../../pages/login/login"; // Adjust the import if necessary

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false); // State to control popup visibility

  // Track scroll position to toggle fixed header
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="headers w-full">
      {/* Top Header */}
      <div
        className={`TopHeader h-10 bg-primary text-white lg:px-[10%] md:px-[5%] px-[10px] flex justify-between items-center transition-transform duration-300 ${
          isScrolled ? "-translate-y-full" : "translate-y-0"
        }`}
      >
        <div className="TopHeaderLeft flex items-center lg:gap-6 md:gap-6 gap-2 lg:text-[17px] text-[8px] md:text-[18px] font-semibold">
          <div className="phone flex items-center gap-2">
            <i className="fa fa-phone text-base" aria-hidden="true"></i>
            <span>+94 762464318</span>
          </div>
          <div className="email flex items-center gap-2">
            <i className="fa fa-envelope text-base" aria-hidden="true"></i>
            <span>example@gmail.com</span>
          </div>
        </div>

        <div className="TopHeaderRight flex items-center lg:gap-5 md:gap-5 gap-3 lg:text-[22px] md:text-[18px] text-[12px]">
          <Link to="facebook">
            <i className="fa fa-facebook" aria-hidden="true"></i>
          </Link>
          <Link to="whatsapp">
            <i className="fa fa-whatsapp" aria-hidden="true"></i>
          </Link>
          <Link to="instagram">
            <i className="fa fa-instagram" aria-hidden="true"></i>
          </Link>
          <Link to="linkedin">
            <i className="fa fa-linkedin" aria-hidden="true"></i>
          </Link>
          <Link to="youtube">
            <i className="fa fa-youtube" aria-hidden="true"></i>
          </Link>
        </div>
      </div>

      {/* Bottom Header */}
      <div
        className={`BottomHeader bg-white shadow-md flex justify-between items-center lg:px-[10%] md:px-[2%] px-[2%] py-2 h-[70px] transition-all duration-300 ${
          isScrolled ? "fixed top-0 left-0 w-full z-50" : ""
        }`}
      >
        <div className="logo w-[240px] h-[150px]">
          <Link to="/">
            <img
              src={Logo}
              alt="Vavuniya Ad Online"
              className="h-full w-full object-contain"
            />
          </Link>
        </div>
        <div className="selectOptions lg:flex md:flex gap-4 hidden">
          <div className="selectLocation">
            <select className="border px-3 py-1 rounded-md">
              <option value="Select Location">Select Location</option>
            </select>
          </div>
          <div className="selectCategory">
            <select className="border px-3 py-1 rounded-md">
              <option value="Select Category">Select Category</option>
            </select>
          </div>
          <div className="search">
            <button className="bg-primary text-white px-4 py-1 rounded-md hover:bg-primary-dark hidden lg:block">
              Search
            </button>
            <div className="flex items-center bg-white rounded-lg shadow-md border border-gray-300 lg:hidden">
              <span className="px-4 text-lg text-gray-900">
                <i
                  className="fa-solid fa-magnifying-glass"
                  aria-hidden="true"
                ></i>
              </span>
            </div>
          </div>
        </div>

        <div className="actionButtons flex gap-2 md:pl-3">
          <Link to="/add-post">
            <button className="bg-white text-black border border-black px-4 py-1 rounded-md hover:bg-gray-100 lg:w-[110px] lg:h-10 md:w-[110px] md:h-10 w-[105px] text-md font-bold">
              Add Post
            </button>
          </Link>
          <button
            onClick={() => setShowLoginPopup(true)} // Show popup on click
            className="bg-primary text-white px-4 py-1 rounded-md hover:bg-primary-dark lg:w-[90px] lg:h-10 md:w-[110px] md:h-10 w-[90px]"
          >
            Log in
          </button>
        </div>
      </div>

      {/* Login Popup */}
      {showLoginPopup && <Sign closePopup={() => setShowLoginPopup(false)} />}
    </div>
  );
}

export default Header;
